const initialProductsState = {
  showId: null,
  showName: null,
  products: [],
  performance: null,
  date: null,
  paxs: 1,
  orderOption: null,
  reservationType: null,
  callCenter: null,
  availabilityRefId: null,
  dateRange: [
    {
      startDate: null,
      endDate: null,
      key: 'selection',
    },
  ],
  transferType: null,
  transferFrom: null,
  transferTo: null,
  reservationTransferRequest: [],
  imageUrl: null,
  hasTransportation: false,
  transportation: null,
  totalAmount: null,
  specialRequests: '',
};

export default (state = initialProductsState, action) => {
  switch (action.type) {
    case 'RESET_RESERVATION':
      return initialProductsState;
    case 'SET_RESERVATION_TYPE':
      return {
        ...state,
        reservationType: action.payload,
      };
    case 'RESERVATION_INFO': {
      return {
        ...state,
        showId: action.payload.showId,
        showName: action.payload.showName,
        products: action.payload.products ? action.payload.products : [],
        performance: action.payload.performance ? action.payload.performance : state.performance,
        date: action.payload.date,
        paxs: action.payload.paxs ? action.payload.paxs : state.paxs,
        callCenter: action.payload.callCenter,
        availabilityRefId: action.payload.availabilityRefId,
        imageUrl: action.payload.imageUrl,
        hasTransportation: action.payload.hasTransportation,
        transferType: action.payload.transferType,
        transferFrom: action.payload.transferFrom,
        transferTo: action.payload.transferTo,
         reservationTransferRequest: action.payload.reservationTransferRequest || state.reservationTransferRequest,
        totalAmount: action.payload.totalAmount, 
        specialRequests: action.payload.specialRequests ?? state.specialRequests,
      };
    }

    case 'RESERVATION_EXTRA_PAX': {
      let newProducts = [...state.products];

      newProducts.forEach((item, i) => {
        newProducts[i].extraPaxs = 0;
      });

      action.payload.forEach((item, i) => {
        let index = newProducts.findIndex((p) => p.id === item.id);

        if (item.specialType === 'EXTRAPAX') {
          if (item.seatProps)
            index = newProducts.findIndex((p) => p.id === item.id && p.seats === item.seatProps.id);
          
          newProducts[index].extraPaxs += item.quantity;
        } else {
          if (index === -1 && item.quantity > 0) {
            newProducts.push({
              id: item.id,
              quantity: item.quantity,
              specialType: item.specialType,
            });
          } else if (index !== -1) {
            if (item.quantity === 0) newProducts.splice(index, 1);
            else newProducts[index].quantity = item.quantity;
          }
        }
      });

      return {
        ...state,
        products: newProducts,
      };
    }
    case 'SET_ORDER_OPTION': {
      return {
        ...state,
        orderOption: action.payload,
      };
    }
    case 'SET_DATE_RANGE': {
      return {
        ...state,
        dateRange: action.payload,
      };
    }
    case 'RESET_TRANSPORTATION':
      return {
        ...state,
        transportation: null,
      };

    case 'SET_TRANSPORTATION': {
      return {
        ...state,
        transportation: {
          price: action.payload.price,
          name: action.payload.name,
          description: action.payload.description,
          time: action.payload.time,
          type: action.payload.type,
        },
      };
    }

    default:
      return state;
  }
};
